import MetalClient, { envTypes } from '@atlassiansox/metal-client';
import { getEnvironment } from '@atlassian/temp-shared/environment';
import { DEVELOPMENT, LOCAL, PRODUCTION, STAGING } from '@atlassian/temp-shared/environment-constants';

export const METAL_ENV = (() => {
  switch (getEnvironment()) {
    case PRODUCTION:
      return envTypes.PROD;
    case DEVELOPMENT:
      return envTypes.DEV;
    case STAGING:
      return envTypes.STAGING;
    case LOCAL:
      return envTypes.LOCAL;
    // Might not be prod but better to be paged about than not
    default:
      return envTypes.STAGING;
  }
})();

export const metalClient = new MetalClient({
  productInfo: {
    metalId: '627999b0-b215-45d7-8441-25acb2ce1d03',
    env: METAL_ENV,
    version: '1.0.0',
  },
});
